/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_TitleInputs */



/**
* | output |
* | --- |
* | "Record movement" |
*
* @param {Promo_Movement_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_title = /** @type {((inputs?: Promo_Movement_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer un mouvement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar movimiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar movimentação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra movimento")
	return /** @type {LocalizedString} */ ("Record movement")
});